import { render, staticRenderFns } from "./cardRatio.vue?vue&type=template&id=7daf830e&scoped=true"
import script from "./cardRatio.vue?vue&type=script&lang=js"
export * from "./cardRatio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7daf830e",
  null
  
)

export default component.exports